import { graphql } from 'gql'

export const UPDATE_DOMAINS = graphql(`
  mutation updateDomains($input: UpdateDomainsInput!) {
    updateDomains(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
